import * as React from 'react'

const SvgPackageIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 18.75H3.75c-.69 0-1.25-.56-1.25-1.25V10c0-.69.56-1.25 1.25-1.25h1.875V10H3.75v7.5h12.5V10h-1.875V8.75h1.875c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25zM8.125 12.5h3.75v1.25h-3.75V12.5zm4.744-7.131l-2.244 2.237V1.25h-1.25v6.356L7.131 5.37l-.881.881L10 10l3.75-3.75-.881-.881z"
      fill="#163250"
    />
  </svg>
)

export default SvgPackageIcon
